export default {
  title01: "Aktuální počasí",
  title02: "24 hodin",
  title03: "Zobrazit 10denní předpověď počasí",
  title04: "AQI",
  title05: "Zobrazit všechny informace",
  title06: "Východ a západ slunce",
  title07: "Fáze Měsíce",
  title08: "Příští úplněk",
  title09: "Příští novoluní",
  title10: "DEN",
  title11: "NOC",
  title12: "Východ slunce",
  title13: "Západ slunce",
  title14: "Východ Měsíce",
  title15: "Západ Měsíce",
  title16: "Zdroj",
  title17: "Začátek",
  title18: "Konec",
  title19: "Použít aktuální polohu",
  title20: "Hledat město",
  title21: "Pocitová teplota",
  title22: "Pocitová teplota (stín)",
  title23: "Nyní",
  title24: "Dnes",
  title25: "NED",
  title26: "PON",
  title27: "ÚTE",
  title28: "STŘ",
  title29: "ČTV",
  title30: "PÁT",
  title31: "SOB",
  title32: "Načítání...",
  title33: "teď",
  title34: "hodinový",
  title35: "každodenní",
  title36: "slunce a měsíc",
  title37: "Kvalita ovzduší",
  title38: "Kontakt: xlf550402@gmail.com",
  title39: "Zásady ochrany osobních údajů",
  title40: "Copyright © comfortweather.com 2020 - 2026. Všechna práva vyhrazena.",
  title41: "Data poskytována",
  title42: "Vysoký",
  title43: "Nízký",
  title44: "Přijmout",
  title45:
    "Děkujeme, že používáte ComfortWeather! Pro lepší ochranu vašich práv a zájmů si před použitím pečlivě přečtěte ",
  title46: "Zásady ochrany osobních údajů",
  title47: " .",
  title48: "",
  title49: "Kontakt: xyjph123@gmail.com",
  title50: "Copyright © 24hweather.com 2020 - 2026. Všechna práva vyhrazena.",
  title51:
    "Děkujeme, že používáte 24hweather! Pro lepší ochranu vašich práv a zájmů si před použitím pečlivě přečtěte ",
  title52: "Byla zjištěna změna vaší polohy, chcete ji aktualizovat?",
  title53: "Potvrdit",
  title54: "Zrušit",
  title55: "Zpět",
  title56: "Zprávy",
  title57: "Aktualizace počasí...",
  title58: "Počasí bylo aktualizováno",
  title59: "Zobrazit vše",
  title60: "Copyright © mobi321.com 2020 - 2026. Všechna práva vyhrazena.",
  title61: "Wčera",
  title62: "Zítra",
  title63: "Zobrazit 15denní předpověď počasí",
  title64: "Dnešní podrobnosti",
  title65: "Rahu Kaal",
  title66: "Životní indexy",
  title67: "Životní indexy",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Těžko se suší",
  title103: "Pomalé sušení",
  title104: "Suší se dobře",
  title105: "Rychlé sušení",
  title106: "Velmi rychlé sušení",

  title107: "Nevhodné",
  title108: "Skromný zážitek",
  title109: "Vhodné pro vodní zábavu",
  title110: "Velmi vhodné",
  title111: "Perfektní podmínky",

  title112: "Podporující zdraví",
  title113: "Neutrální podmínky",
  title114: "Mírně vyšší riziko",
  title115: "Vysoké riziko",
  title116: "V extrémním riziku",

  title117: "Nepřijatelné",
  title118: "Částečně vhodné",
  title119: "Vhodné pro venkovní aktivity",
  title120: "Velmi vhodné",
  title121: "Vynikající podmínky",

  title122: "Velmi suché podmínky",
  title123: "Pravděpodobně suché",
  title124: "Mírně suché",
  title125: "Nepravděpodobně suché",
  title126: "Velmi nepravděpodobně suché",

  title127: "Není doporučeno",
  title128: "Přijatelné",
  title129: "Dobrý den",
  title130: "Velmi dobré podmínky",
  title131: "Ideální podmínky",
};
